import React, { useState, useContext, useEffect } from 'react'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import { useDistrict } from '../../hooks/CompanyConfiguration/useDistrict'
import { ROUTES } from '../../shared/constants'
import { useLocation } from '../../hooks/Location/useLocation'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useRegion } from '../../hooks/CompanyConfiguration/useRegion'
import { sortByName } from '../../shared/constants'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'


function DistrictForm() {
  const [districtData, setDistrictData] = useState({
    name: '',
    region: '',
    zone: '',
    state: '',
    districtCode: '',
  })

  const { addDistrict, loading } = useDistrict()
  const { getAllRegion } = useRegion()

  const { regions } = useContext(ConfigurationContext)

  const { zones, getAllZone, getAllState, states } = useLocation()

  useEffect(() => {
    getAllRegion()
  }, [])

  useEffect(() => {
    if (districtData.region) {
      getAllZone({ region: districtData.region })
    }
    if (districtData.zone) {
      getAllState({ region: districtData.region, zone: districtData.zone })
    }
  }, [districtData])

  const data = [
    { label: 'District Code', value: districtData.districtCode, name: 'districtCode' },
    { label: 'Name', value: districtData.name, name: 'name' },
    { label: 'Region', value: districtData.region, name: 'region', options: sortByName(regions), fieldName: 'name', fieldValue: '_id' },
    { label: 'Zone', value: districtData.zone, name: 'zone', options: sortByName(zones), fieldName: 'name', fieldValue: '_id' },
    { label: 'State', value: districtData.state, name: 'state', options: sortByName(states), fieldName: 'name', fieldValue: '_id' },
  ]

  const handleDistrict = () => {
    addDistrict(districtData)
  }

  return (
    <Layout heading="Add District" heading2="Add" url1={ROUTES.DISTRICT} none>
      <HeaderTabLayout
        heading="Add District"
        content={<CustomAddForm state={districtData} setState={setDistrictData} data={data} />}
        addContent={handleDistrict}
        redirect={ROUTES.DISTRICT}
        state={districtData} setState={setDistrictData}
        loading={loading}
      />
    </Layout>
  )
}

export default DistrictForm
